import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './radio_with_content.less'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import FirstChild from 'components/common/first_child'

const TRANSITION_DURATION = 250

class RadioWithContent extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    fieldValue: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    styles: PropTypes.object,
    autoFocus: PropTypes.bool,
    dataNemo: PropTypes.string,
  }

  render() {
    const transitionNames = {
      enter: this.props.styles['content-enter'],
      enterActive: this.props.styles['content-enter-active'],
      leave: this.props.styles['content-leave'],
      leaveActive: this.props.styles['content-leave-active'],
    }

    return (
      <div styleName="radio-with-content">
        <div className="vx_radio">
          <input
            type="radio"
            id={this.props.id}
            value={this.props.value}
            checked={this.props.fieldValue === this.props.value}
            onChange={this.props.onChange}
            name={this.props.name}
            autoFocus={this.props.autoFocus}
          />
          <label htmlFor={this.props.id} data-nemo={this.props.dataNemo}>
            {this.props.label}
          </label>
        </div>
        <ReactCSSTransitionGroup
          component={FirstChild}
          transitionName={transitionNames}
          transitionEnterTimeout={TRANSITION_DURATION}
          transitionLeaveTimeout={TRANSITION_DURATION}
        >
          {this.props.value === this.props.fieldValue && this.props.children ? (
            <div styleName="content">
              <div styleName="content-hugger">{this.props.children}</div>
            </div>
          ) : (
            ''
          )}
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

export default cssModules(RadioWithContent, styles)
